import axios from 'axios'
import {
    clearAuthStorage,
    getAccessToken,
} from './authStorage'
import {
    applyAccessTokenToAxios,
    attachAuthRefreshInterceptor,
} from './authRefresh'
import { getCsrfHeaders } from './csrf'

let isConfigured = false

function redirectToSignIn() {
    const path = window.location.pathname || ''
    if (path.includes('/session/')) return
    window.location.href = '/session/signin'
}

function onAuthFailure() {
    clearAuthStorage()
    applyAccessTokenToAxios(null)
    redirectToSignIn()
}

/**
 * Configure the shared axios singleton (all `import axios from 'axios'`).
 * Call once at app startup (see src/index.jsx).
 */
export function setupAxios() {
    if (isConfigured) return axios
    isConfigured = true

    axios.defaults.withCredentials = true

    axios.interceptors.request.use(
        (config) => {
            const token = getAccessToken()
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
            const csrf = getCsrfHeaders(config.method)
            if (csrf && Object.keys(csrf).length) {
                config.headers = { ...config.headers, ...csrf }
            }
            return config
        },
        (error) => Promise.reject(error)
    )

    // Register first so the refresh handler (added next) runs before this on 401s.
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const payload =
                (error.response && error.response.data) ||
                error.message ||
                'Something went wrong!'
            return Promise.reject(payload)
        }
    )

    attachAuthRefreshInterceptor(axios, { onAuthFailure })

    const token = getAccessToken()
    applyAccessTokenToAxios(token)

    return axios
}

export default setupAxios

setupAxios()
